const state = {
    lastRoute: null
}

const mutations = {
    SET_LAST_ROUTE (state, lastRoute) {
        state.lastRoute = lastRoute
    },
}

const actions = {
    async setLastRoute (store, lastRoute) {
        store.commit('SET_LAST_ROUTE', lastRoute)
    }
}

const getters = {
    getLastRoute: state => {
        return state.lastRoute
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
